import apiClient from '@/lib/api/apiClient'
import { API_ENDPOINTS } from '@/lib/api/config'
import type { ApplicationListResponse, ApplicationFilters } from '../types/application'
import { throwServiceError } from './serviceHelpers'

/** Application list with filters and pagination. */
export async function getApplicationList(
  filters: ApplicationFilters,
): Promise<ApplicationListResponse> {
  try {
    const params = new URLSearchParams()

    if (filters.page) params.append('page', String(filters.page))
    if (filters.perPage) params.append('perPage', String(filters.perPage))
    if (filters.sortBy) params.append('sortBy', filters.sortBy)
    if (filters.orderBy) params.append('orderBy', filters.orderBy)

    const trimmedSearch = filters.search?.trim()
    if (trimmedSearch) params.append('search', trimmedSearch)
    if (filters.employer_search) params.append('employer_search', filters.employer_search)
    if (filters.past_customer) params.append('past_customer', filters.past_customer)
    if (filters.company_id) params.append('company_id', String(filters.company_id))
    if (filters.property_id) params.append('property_id', String(filters.property_id))

    if (filters.fromDt) params.append('fromDt', filters.fromDt)
    if (filters.toDt) params.append('toDt', filters.toDt)

    if (filters.applicantStatus?.length) {
      filters.applicantStatus.forEach((status) => {
        params.append('applicantStatus[]', status)
      })
    }
    if (filters.progress_status?.length) {
      filters.progress_status.forEach((status) => {
        params.append('progress_status[]', status)
      })
    }
    if (filters.product_id?.length) {
      filters.product_id.forEach((id) => {
        params.append('product_id[]', String(id))
      })
    }
    if (filters.risk_rating?.length) {
      filters.risk_rating.forEach((label) => {
        params.append('risk_rating[]', label)
      })
    }

    const response = await apiClient.get<ApplicationListResponse>(
      `${API_ENDPOINTS.APPLICATION_LIST}?${params.toString()}`,
    )

    return response.data
  } catch (error) {
    throwServiceError(error, 'Failed to fetch application list.')
  }
}

/** Impersonate user role — returns new auth token. */
export async function impersonateUser(roleId: number): Promise<string> {
  try {
    const response = await apiClient.post<{ token: string } | string>(
      API_ENDPOINTS.IMPERSONATE,
      { role_id: roleId },
    )

    if (typeof response.data === 'string') {
      return response.data
    }
    return response.data.token || ''
  } catch (error) {
    throwServiceError(error, 'Failed to impersonate user.')
  }
}
